import React from "react";
import {withRouter} from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Button from "components/CustomButtons/Button.jsx";
import CircularProgress from '@material-ui/core/CircularProgress';

import ToolTipIcon from "views/Components/ToolTipIcon"
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { verifyLength, verifyNumber, verifyMatchingNumbers, setToolTipArray } from "../../../assets/helpers/formHelper";
import axios from "axios";
import { getApiHeaders } from "../../../assets/helpers/apiHelper";
import { API_ROOT } from 'api-config';

import PreLoginHeader from "components/Header/PreLoginHeader.jsx";
import CreditCard from "views/Components/CreditCard.jsx"
// @material-ui/icons
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import { getSearchString } from "../../../assets/helpers/urlHelper";
import queryString from 'qs'
import { getUserGroups } from "../../../assets/helpers/utilityHelper";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  ...customSelectStyle,
  ...regularFormsStyle
};

const paymentTabs = ['A', 'C']
var userGroups = getUserGroups()
class Payment extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    var isProviderSignup;
    var headerText;
    var showConfirmButton = false
    var showVerifyButton = true
    var saveCardOnSubmit = false
    var showPreLoginHeader = false
    var loadBankInfo = false
    var userId = sessionStorage.getItem('userId')
    var submitButtonText = 'submit'
    var reloadAfterSubmit = true
    var acceptCreditCards = false
    var lookUpShowCreditCardInput = false
    var showTooltips = true
    var inDialog = false
    var formControlMargin = 'none'
    var customInputStyle = ''
    if (this.props.location.pathname === '/signupProvider' || userGroups.indexOf('assessment') >= 0) {
      isProviderSignup = true
      headerText = 'Please provide your bank information for direct deposit payments.'
    } else {
      isProviderSignup = false
      headerText = 'Please provide your payment information.'
    }
    if (this.props.lookUpShowCreditCardInput) {
      lookUpShowCreditCardInput = this.props.lookUpShowCreditCardInput
    }

    if (this.props.embedded) {
      headerText = ''
      showPreLoginHeader = false
      loadBankInfo = true
      userId = this.props.userId
      submitButtonText = 'update'
      reloadAfterSubmit = false
      showTooltips = false
      if (this.props.inRegistration) {
        showVerifyButton = true
        saveCardOnSubmit = false
        showConfirmButton = false
      } else {
        showVerifyButton = false
        saveCardOnSubmit = true
        showConfirmButton = true
      }
    } else if (this.props.location.pathname.substring(0,7) !== '/signup' && userGroups.indexOf('assessment') < 0) {
      headerText = 'You need to provide your bank information for payment before you proceed.'
      showConfirmButton = true
      showPreLoginHeader = true
      showVerifyButton = false
      saveCardOnSubmit = true
      lookUpShowCreditCardInput = true
    }
    if (this.props.acceptCreditCards) {
      acceptCreditCards = this.props.acceptCreditCards
    }
    if (props.inDialog) {
      inDialog = props.inDialog
      formControlMargin = 'dense'
      customInputStyle = {marginTop: "24px"}
    }
    const chargeCreditCardFee = this.props.chargeCreditCardFee ? this.props.chargeCreditCardFee : false;
    const creditCardFee = this.props.creditCardFee ? this.props.creditCardFee : '';


    this.state = {
      routingNumber: '',
      routingNumberState: '',
      accountNumber: '',
      accountNumberState: '',
      accountNumber2: '',
      accountNumber2State: '',
      accountType: '',
      accountTypeState: '',
      validAccount: '',
      validAccountStatusIndicator: '',
      disableUpdateButton: false,
      bankName: '',
      bankNameState: '',
      creditCardTxToken: '',
      creditCardProcessor: '',
      paymentMethod: 'A',
      selectedPaymentTab: 0,
      requireRoutingNumber: true,
      requireAccountNumber: true,
      requireAccountType: true,
      routingNumberRequiredText: '(required)',
      accountNumberRequiredText: '(required)',
      accountNumberErrorMessage: '',
      isProviderSignup: isProviderSignup,
      tooltips: {},
      headerText: headerText,
      showConfirmButton: showConfirmButton,
      showPreLoginHeader: showPreLoginHeader,
      showVerifyButton: showVerifyButton,
      saveCardOnSubmit: saveCardOnSubmit,
      loadBankInfo: loadBankInfo,
      userId: userId,
      submitButtonText: submitButtonText,
      reloadAfterSubmit: reloadAfterSubmit,
      paymentMethodDisplay: '',
      acceptCreditCards: acceptCreditCards,
      chargeCreditCardFee: chargeCreditCardFee,
      creditCardFee: creditCardFee,
      showTooltips: showTooltips,
      inDialog: inDialog,
      formControlMargin: formControlMargin,
      customInputStyle: customInputStyle,
      lookUpShowCreditCardInput: lookUpShowCreditCardInput,
      showInsufficientFundsButton: false
    };
  }
  sendState() {
    return this.state;
  }
  change(event, stateName, type, stateNameEqualTo, emptyOkay) {
    if (emptyOkay && !event.target.value) {
      this.setState({ [stateName + "State"]: "" });
    } else {
      switch (type) {
        case "routingNumber":
          if ((verifyNumber(event.target.value) && verifyLength(event.target.value, stateNameEqualTo, true)) ||
              (event.target.value === '' && !this.state.requireRoutingNumber)) {
            this.setState({ [stateName + "State"]: "success" });
            //if it is verified, also get the bank name
            this.getBankName(event.target.value);
          } else {
            this.setState({ [stateName + "State"]: "error" });
            this.setState({ bankName: '' })
          }
          break;
        case "number":
          if (verifyNumber(event.target.value) || (event.target.value === '' && !this.state.requireAccountNumber)) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "accountType":
          if (event.target.value || !this.state.requireAccountType) {
            this.setState({ accountTypeState: "success" });
          } else {
            this.setState({ accountTypeState: "error" });
          }
          break;
        case "accountNumberMatch":
          var verifyData = ""
          var accountNumberErrorMessage = ""
          if (event.target.id === 'accountNumber') {
            verifyData = verifyMatchingNumbers(event.target.value, this.state.accountNumber2, this.state.requireAccountNumber)
          } else if (event.target.id === 'accountNumber2') {
            verifyData = verifyMatchingNumbers(event.target.value, this.state.accountNumber, this.state.requireAccountNumber)

          }
          if (verifyData.showMismatch) {
            accountNumberErrorMessage = "The account numbers do not match."
          } else {
            accountNumberErrorMessage = ""
          }
          this.setState({
            accountNumberState: verifyData.matchStatus,
            accountNumber2State: verifyData.matchStatus,
            accountNumberErrorMessage: accountNumberErrorMessage
          });
          break;
        default:
          break;
      }
      if (this.props.updateParentState) {
        this.props.updateParentState(stateName, event.target.value)
      }
    }

    this.setState({ [stateName]: event.target.value });
  };
  isValidated() {
    if (this.state.paymentMethod === 'C') {
      if (this.state.creditCardTxToken !== '') {
        return true
      } else {
        return false
      }
    } else if (this.state.paymentMethod === "A") {
      if (
        this.state.routingNumberState === "success" &&
        this.state.accountNumberState === "success" &&
        this.state.accountNumber2State === "success" &&
        this.state.accountTypeState === "success" &&
        this.state.bankNameState === "success"
      ) {
        return true;
      } else {
        if (this.state.routingNumberState !== "success") {
          this.setState({ routingNumberState: "error" });
        }
        if (this.state.accountNumberState !== "success") {
          this.setState({ accountNumberState: "error" });
        }
        if (this.state.accountNumber2State !== "success") {
          this.setState({ accountNumber2State: "error" });
        }
        if (this.state.accountTypeState !== "success") {
          this.setState({ accountTypeState: "error" });
        }
        if (this.state.bankNameState !== "success") {
          this.setState({ bankNameState: "error" });
        }
      }
      return false;
    }
  }

  setCreditCardToken(token, processor) {
    this.setState({ creditCardTxToken: token,
                    creditCardProcessor: processor })
    if (this.props.updateParentState) {
      this.props.updateParentState('creditCardTxToken', token)
      this.props.updateParentState('creditCardProcessor', processor)
    }
  }

  getBankName(routingNumber) {
    if (!routingNumber) {
      routingNumber = this.state.routingNumber;
    }
    if (routingNumber.length === 9) {
      axios.get(`${API_ROOT}/routingNumber/?routingNumber=` + routingNumber, { headers: getApiHeaders() })
        .then(res => this.setBankName(res));
    } else {
      this.setState({ bankName: '' })
    }
  }

  setBankName(res) {
    var bankName = ''
    var bankNameState = ''
    var routingNumberState = ''
    if (res.data.customerName) {
      bankName = res.data.customerName
      bankNameState = 'success'
      routingNumberState = 'success'
    } else {
      bankName = 'INVALID ROUTING NUMBER'
      bankNameState = 'error'
      routingNumberState = 'error'
    }
      this.setState({ bankName: bankName,
                      bankNameState: bankNameState,
                      routingNumberState: routingNumberState })
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.state.isProviderSignup) {
      this.setState({
        requireRoutingNumber: false,
        requireAccountNumber: false,
        requireAccountType: false,
        accountTypeState: "success",
        accountNumberState: "success",
        accountNumber2State: "success",
        routingNumberState: "success",
        bankNameState: "success",
        routingNumberRequiredText: '',
        accountNumberRequiredText: ''
      })
    }
    var formType;
    if (this.state.isProviderSignup) {
      formType = 'registrationPaymentProvider'
    } else {
      formType = 'registrationPayment'
    }

    if (this.state.loadBankInfo && this.state.userId) {
      this.getPaymentMethod()
      axios.get(`${API_ROOT}/financialAccount/?userId=`+this.state.userId, {headers: getApiHeaders()})
        .then(res => this.setFinancialAccountValues({responseMessage: res.data}));
    }
    if (this.state.showTooltips) {
      axios.get(`${API_ROOT}/toolTip/?formType=` + formType, { headers: getApiHeaders() })
        .then(res => this.setTooltips({ responseMessage: res.data }));
    }
    const searchString = getSearchString(this.props.location.search)
    const values = queryString.parse(searchString)
    if (values.postLoginMessage) {
      alert(values.postLoginMessage)
    }
    if (this.state.lookUpShowCreditCardInput) {
      this.lookUpShowCreditCardInput()
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  static getDerivedStateFromProps(nextProps, prevState){
    if (prevState.acceptCreditCards !== nextProps.acceptCreditCards && nextProps.acceptCreditCards && nextProps.acceptCreditCards !== 'none') {
      return { acceptCreditCards: nextProps.acceptCreditCards};
    } else if (nextProps.allStates !=='' && nextProps.allStates !=='' && nextProps.allStates !== undefined) {
      var acceptCreditCards = '';
      var chargeCreditCardFee = '';
      var creditCardFee = '';
      for (var i = nextProps.allStates.length - 1; i >= 0; i--) {
        if (nextProps.allStates[i]) {
          var objectKey = Object.keys(nextProps.allStates[i])[0]
          if (objectKey === 'provider') {
            acceptCreditCards = nextProps.allStates[i]['provider']['selectedProviderAcceptCreditCards']
            chargeCreditCardFee = nextProps.allStates[i]['provider']['selectedProviderChargeCreditCardFee']
            creditCardFee = nextProps.allStates[i]['provider']['selectedProviderCreditCardFee']
            break;
          }
        }
      }
      return { acceptCreditCards: acceptCreditCards, chargeCreditCardFee: chargeCreditCardFee, creditCardFee: creditCardFee};
    }
    else return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.acceptCreditCards!==this.props.acceptCreditCards ||
      prevProps.chargeCreditCardFee!==this.props.chargeCreditCardFee ||
      prevProps.creditCardFee!==this.props.creditCardFee){
      //Perform some operation here
      this.setState({
        acceptCreditCards: this.props.acceptCreditCards,
        chargeCreditCardFee: this.props.chargeCreditCardFee,
        creditCardFee: this.props.creditCardFee
      });
    }
  }

  setTooltips(tooltipData) {
    this.setState({
      tooltips: setToolTipArray(tooltipData)
    })
  }

  updateBankInformation(){
    const matchingNumbers = verifyMatchingNumbers(this.state.accountNumber, this.state.accountNumber2)
    if (matchingNumbers.showMismatch) {
      alert("The account number and account number confirmation value do not match. Please correct this issue.")
    } else if (!verifyNumber(this.state.routingNumber, 9, true) || matchingNumbers.matchStatus === 'error'){
      alert("Please enter a numeric routing and account number before updating.")
    } else if (!this.state.bankName || this.state.bankName === ''|| this.state.bankName === 'INVALID ROUTING NUMBER') {
      alert("Please enter a valid routing number before updating. There is no bank associated with this routing number")
    } else {
      this.setState({
        responseMessageFinancialAccount: 'submitting',
        disableUpdateButton: true
      })
      const financialAccountData = {
        userId: this.state.userId,
        routingNumber: this.state.routingNumber,
        accountNumber: this.state.accountNumber,
        accountType: this.state.accountType
      }
      axios.post(`${API_ROOT}/financialAccount/`, financialAccountData, { headers: getApiHeaders() })
        .then(res => this.handleUpdateBankInformation(res));
    }
  }

  handleUpdateBankInformation(res) {
    this.setState({
      responseMessageFinancialAccount: '',
      disableUpdateButton: false
    })
    if (res.data['message'] === 'success') {
      if (this.state.reloadAfterSubmit) {
        sessionStorage.setItem('bankAccountSet', true);
        window.location = '/'
      } else {
        this.updatePaymentMethodDisplay('e-check')
      }
      this.setValidAccount(res.data['validAccount'])
    } else {
      var errorMessage = ''
      if (res.data['message']) {
        errorMessage = "There was an error updating your account: " + res.data['message']
      } else {
        errorMessage = "There was an unknown error updating your account."
      }
      alert(errorMessage)
    }

  }

  validateBankAccount() {
    const validateData = {
      userId: this.state.userId,
      validAccount: 'T'
    }


    this.setState({
      validAccount: 'updating... ',
      validAccountStatusIndicator: <CircularProgress size={20}/>,
      disableUpdateButton: true
    });

    axios.post(`${API_ROOT}/financialAccountsValidate/`, validateData, { headers: getApiHeaders() })
      .then(res => this.handleValidateBankAccount(res));
  }

  handleValidateBankAccount(res) {
    this.setState({
      disableUpdateButton: false
    });
    var alertMessage = ''
    if (res.status !== 200) {
      alertMessage = 'an unknown error occurred'
    } else {
      if (res.data['error']) {
        alertMessage = res.data['error']
      } else if (res.data['status']) {
        if (res.data['status'] === 'success') {
          this.setValidAccount(res.data['validAccount'])
        } else {
          alertMessage = res.data['status']
        }
      } else {
        alertMessage = 'an unknown error occurred'
      }
    }

    if (alertMessage !== '') {
      alert(alertMessage)
    }
  }

  handleTabsChange(newTabId) {
    this.setState({
      paymentMethod: paymentTabs[newTabId]
    })
    if (this.props.updateParentState) {
      this.props.updateParentState('paymentMethod', paymentTabs[newTabId])
    }
  }


  setFinancialAccountValues(financialAccountData) {
    if (this._isMounted) {
      if (!financialAccountData.responseMessage.error) {

        var accountNumberDisplay = 'XXXXX' + financialAccountData.responseMessage.accountNumber.substr(financialAccountData.responseMessage.accountNumber.length - 4)
        this.setValidAccount(financialAccountData.responseMessage.validAccount, financialAccountData.responseMessage.invalidReason)

        this.setState({
          routingNumber: financialAccountData.responseMessage.routingNumber,
          accountNumber: financialAccountData.responseMessage.accountNumber,
          accountNumber2: financialAccountData.responseMessage.accountNumber,
          accountNumberDisplay: accountNumberDisplay,
          accountNumber2Display: accountNumberDisplay,
          accountType: financialAccountData.responseMessage.accountType,
        });
        this.getBankName()
      }
    }
  }

  setValidAccount(validAccountCode, invalidReason = '') {
    var validAccount = ''
    var showInsufficientFundsButton = false
    // invalid reason is not passed if user updates the account info, but we may still need to use it
    // so set it to the invalid reason state
    if (invalidReason === '' && this.state.invalidReason !== '') {
      invalidReason = this.state.invalidReason
    }
    if (validAccountCode === 'P') {
      validAccount = 'pending verification'
    } else if (validAccountCode === 'T') {
      validAccount = 'verified'
    } else if (validAccountCode === 'F') {
      validAccount = 'Invalid account - ' + invalidReason + '. Please update account information.'
    } else if (validAccountCode === 'I') {
      validAccount = 'insufficient funds'
      showInsufficientFundsButton = true
    }
    if (validAccountCode !== 'F') {
      invalidReason = ''
    }
    this.setState({
      validAccount: validAccount,
      invalidReason: invalidReason,
      validAccountStatusIndicator: '',
      showInsufficientFundsButton: showInsufficientFundsButton
    });
  }

  getPaymentMethod(){
    axios.get(`${API_ROOT}/paymentMethod/?userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setPaymentMethod({responseMessage: res.data}));
  }

  setPaymentMethod(res) {
    if (res.responseMessage) {
      var paymentMethod = res.responseMessage.paymentMethod
      if (paymentMethod === '') {
        paymentMethod = 'A'
      }
      var selectedPaymentTab = paymentTabs.indexOf(paymentMethod)
      var paymentMethodDisplay;
      if (paymentMethod === 'A') {
        paymentMethodDisplay = 'e-check'
      } else if (paymentMethod === 'C') {
        paymentMethodDisplay = 'credit card'
      }
      if (this.props.updateParentState) {
        this.props.updateParentState('paymentMethod', paymentMethod)
      }
      this.setState({
        paymentMethod: paymentMethod,
        selectedPaymentTab: selectedPaymentTab,
        paymentMethodDisplay: paymentMethodDisplay
      })
    }
  }

  updatePaymentMethodDisplay(newPaymentMethod) {
    this.setState({
      paymentMethodDisplay: newPaymentMethod
    })
  }

  lookUpShowCreditCardInput() {
    axios.get(`${API_ROOT}/provider/?userId=`+this.state.userId+`&isPrimary=1`, {headers: getApiHeaders()})
      .then(res => this.setShowCreditCardInput({responseMessage: res.data}));
  }

  setShowCreditCardInput(res) {
    if (this._isMounted) {
      if (res.responseMessage.length > 0) {
        this.setState({
          acceptCreditCards: res.responseMessage[0].acceptCreditCards,
          chargeCreditCardFee: res.responseMessage[0].chargeCreditCardFee,
          creditCardFee: res.responseMessage[0].creditCardFee
        })
      }
    }
  }


  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridItem xs={12} sm={12} style={this.state.showPreLoginHeader ? {} : { display: 'none' }} >
          <PreLoginHeader />
        </GridItem>
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={12}>
            <h4 className={classes.infoText} id={'paymentHeader'}>{this.state.headerText}</h4>
          </GridItem>
          <GridItem xs={12} sm={12} style={this.state.paymentMethodDisplay ? {} : { display: 'none' }} id={'paymentMethodDisplay'}>
            Currently paying by {this.state.paymentMethodDisplay}.
          </GridItem>
          <GridItem xs={12} sm={12} style={this.state.paymentMethodDisplay ? {} : { display: 'none' }}>
            To update the payment method, enter/confirm the payment details and click the update button.
          </GridItem>
          <GridItem xs={12} sm={12}>
            <CustomTabs
              captureTabChange = {this.handleTabsChange.bind(this)}
              title="payment method:"
              selectedTab={this.state.selectedPaymentTab}
              tabs={[
                {
                  showTab: true,
                  tabName: "e-check",
                  tabContent: (
                    <div>
                      <GridItem xs={12} sm={12}>
                        <CustomInput
                          success={this.state.routingNumberState === "success"}
                          error={this.state.routingNumberState === "error"}
                          labelText={
                            <span>
                  routing number <small>{this.state.routingNumberRequiredText}</small>
                </span>
                          }
                          id="routingNumber"
                          formControlProps={{
                            fullWidth: true,
                            margin: this.state.formControlMargin
                          }}
                          inputProps={{
                            onChange: event => this.change(event, "routingNumber", "routingNumber", '9'),
                            endAdornment: (
                              <ToolTipIcon
                                tooltipText={this.state.tooltips['routingNumber']}
                              />
                            ),
                            value: this.state.routingNumber
                          }}
                          customStyle={this.state.customInputStyle}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12}>
                        Bank: {this.state.bankName}
                      </GridItem>
                      <GridItem xs={12} sm={12}>
                        <CustomInput
                          success={this.state.accountNumberState === "success"}
                          error={this.state.accountNumberState === "error"}
                          labelText={
                            <span>
                  account number <small>{this.state.accountNumberRequiredText}</small>
                </span>
                          }
                          id="accountNumber"
                          formControlProps={{
                            fullWidth: true,
                            margin: this.state.formControlMargin
                          }}
                          inputProps={{
                            onChange: event => this.change(event, "accountNumber", "accountNumberMatch"),
                            endAdornment: (
                              <ToolTipIcon
                                tooltipText={this.state.tooltips['accountNumber']}
                              />
                            ),
                            value: this.state.accountNumber
                          }}
                          customStyle={this.state.customInputStyle}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12}>
                        <CustomInput
                          success={this.state.accountNumber2State === "success"}
                          error={this.state.accountNumber2State === "error"}
                          labelText={
                            <span>
                    account number - confirm <small>{this.state.accountNumberRequiredText}</small>
                  </span>
                          }
                          id="accountNumber2"
                          formControlProps={{
                            fullWidth: true,
                            margin: this.state.formControlMargin
                          }}
                          inputProps={{
                            onChange: event => this.change(event, "accountNumber2", "accountNumberMatch"),
                            endAdornment: (
                              <ToolTipIcon
                                tooltipText={this.state.tooltips['accountNumber']}
                              />
                            ),
                            value: this.state.accountNumber2
                          }}
                          customStyle={this.state.customInputStyle}
                        />

                        <p id="accountNumberErrorMessage">
                          {this.state.accountNumberErrorMessage}
                        </p>
                      </GridItem>
                      <GridItem xs={12} sm={12}>
                        <FormControlLabel
                          control={
                            <Radio
                              checked={this.state.accountType === "C"}
                              onChange={event => this.change(event, "accountType", "accountType")}
                              value="C"
                              name="accountType"
                              aria-label="C"
                              icon={
                                <FiberManualRecord
                                  className={classes.radioUnchecked}
                                />
                              }
                              checkedIcon={
                                <FiberManualRecord
                                  className={classes.radioChecked}
                                />
                              }
                              classes={{
                                checked: classes.radio,
                                root: classes.radioRoot
                              }}
                            />
                          }
                          classes={{
                            label: classes.label
                          }}
                          label="checking"
                        />
                        <FormControlLabel
                          control={
                            <Radio
                              checked={this.state.accountType=== "S"}
                              onChange={event => this.change(event, "accountType", "accountType")}
                              value="S"
                              name="accountType"
                              aria-label="S"
                              icon={
                                <FiberManualRecord
                                  className={classes.radioUnchecked}
                                />
                              }
                              checkedIcon={
                                <FiberManualRecord
                                  className={classes.radioChecked}
                                />
                              }
                              classes={{
                                checked: classes.radio,
                                root: classes.radioRoot
                              }}
                            />
                          }
                          classes={{
                            label: classes.label
                          }}
                          label="savings"
                        />
                      </GridItem>

                      <GridItem xs={12} sm={5} style={this.state.showConfirmButton ? {} : { display: 'none' }}>
                        <Button
                          className={classes.updateProfileButton}
                          onClick={() => this.updateBankInformation()}
                          round
                          color="cirrusBlue"
                          disabled={this.state.disableUpdateButton}
                          id="updateBankInformationButton"
                        >
                          {this.state.submitButtonText}
                        </Button>
                      </GridItem>
                      <GridItem xs={12} sm={5} style={this.state.showConfirmButton ? {} : { display: 'none' }}>
                      account status: {this.state.validAccount} {this.state.validAccountStatusIndicator}
                      </GridItem>
                      <GridItem xs={12} sm={7} style={this.state.showInsufficientFundsButton ? {} : { display: 'none' }}>
                        <Button
                          className={classes.updateProfileButton}
                          onClick={() => this.validateBankAccount()}
                          round
                          color="cirrusBlue"
                          disabled={this.state.disableUpdateButton}
                          id="validateBankAccountButton"
                        >
                          verify sufficient funds are now available
                        </Button>
                      </GridItem>


                    </div>
                  )
                },
                {
                  showTab: this.state.acceptCreditCards,
                  tabName: "credit card",
                  tabContent: (

                      <CreditCard
                        setToken = {this.setCreditCardToken.bind(this)}
                        showVerifyButton = {this.state.showVerifyButton}
                        saveCardOnSubmit = {this.state.saveCardOnSubmit}
                        loadBankInfo = {this.state.loadBankInfo}
                        userId = {this.state.userId}
                        submitButtonText = {this.state.submitButtonText}
                        reloadAfterSubmit = {this.state.reloadAfterSubmit}
                        postUpdateAction = {this.updatePaymentMethodDisplay.bind(this)}
                        chargeCreditCardFee = {this.state.chargeCreditCardFee}
                        creditCardFee = {this.state.creditCardFee}
                      />

                  )
                }
              ]}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withRouter(withStyles(style)(Payment));
